import React from 'react';
import TableCuppingsCard from './TableCuppingsCard'

const MultipleTableCuppings = ({ tableCuppings, isLoggedIn }) => {
    const tableCuppingsList = tableCuppings.map(tableCupping => (
        <TableCuppingsCard key={tableCupping.id} table={tableCupping} catadorId={tableCupping.catador_id} isLoggedIn={isLoggedIn} />
    ))
    return <div style={{display: 'block', flexDirection: 'row'}} className="cardsContainer">{tableCuppingsList}</div>
}

export default MultipleTableCuppings